import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

import {
  FaHome,
  FaHandHolding,
} from "react-icons/fa";
import { MdEventNote, MdEventAvailable } from "react-icons/md";
import { PiSuitcaseSimpleBold } from "react-icons/pi";
import { SiGoogleforms } from "react-icons/si";
import { RiSuitcaseFill } from "react-icons/ri";
import { IoPersonCircle } from "react-icons/io5";

function HrSidebar() {

  const [user, setUser] = useState(null);

  useEffect(() => {
    /* =========================================
       ✅ FIXED — was reading "loggedInUser",
       the same shared key StudentLogin.js used.
       Now reads "hrLoggedInUser", role-scoped
       to HR/Employee only.
    ========================================= */
    const loadUser = () => {
      try {
        const storedUser = JSON.parse(
          localStorage.getItem("hrLoggedInUser")
        );
        if (storedUser) setUser(storedUser);
      } catch (err) {
        console.log("Failed to parse hrLoggedInUser", err);
      }
    };

    loadUser();

    window.addEventListener("userLoggedIn", loadUser);
    window.addEventListener("storage", loadUser);

    return () => {
      window.removeEventListener("userLoggedIn", loadUser);
      window.removeEventListener("storage", loadUser);
    };
  }, []);

  const getDisplayName = () => {
    const name = user?.full_name;
    const isPlaceholder =
      !name ||
      name.trim() === "" ||
      name.trim().toLowerCase() === "string";

    if (!isPlaceholder) return name;

    return user?.email || "HR";
  };

  const getInitial = () => {
    const name = getDisplayName();
    return name?.charAt(0)?.toUpperCase() || "H";
  };

  const totalJobs = user?.total_jobs ?? 6;

  const menuItems = [
    {
      to: "/hrdashboard/HrDashboardHome",
      icon: <FaHome className="hrsidebar-icon" />,
      label: "Dashboard",
    },
    {
      to: "/hrdashboard/Livejobpost",
      icon: <PiSuitcaseSimpleBold className="hrsidebar-icon" />,
      label: "Job Posts",
    },
    // {
    //   to: "/hrdashboard/Previousjobs",
    //   icon: <FaHandHolding className="hrsidebar-icon" />,
    //   label: "View Jobs",
    // },
    {
      to: "/hrdashboard/Hrlivetraining",
      icon: <MdEventNote className="hrsidebar-icon" />,
      label: "Live Training Program",
    },
    {
      to: "/hrdashboard/Hrliveevents",
      icon: <MdEventAvailable className="hrsidebar-icon" />,
      label: "Live Event Program",
    },
    {
      to: "/hrdashboard/Hrjobfairs",
      icon: <RiSuitcaseFill className="hrsidebar-icon" />,
      label: "Job & JobFairs",
      badge: 2,
    },
    {
      to: "/hrdashboard/Blackprofile",
      icon: <IoPersonCircle className="hrsidebar-icon" />,
      label: "Black Profile",
    },
  ];

  return (
    <>
      <style>{`
        .hrsidebar-wrapper {
          width: 240px;
          background: #ffffff;
          border-right: 1px solid #e6e6e6;
          display: flex;
          flex-direction: column;
          font-family: "Poppins", sans-serif;
          position: fixed;
          top: 60px;
          left: 0;
          height: calc(100vh - 60px);
          overflow-y: auto;
          z-index: 1000;
        }

        .hrsidebar-profile {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 18px 16px;
          border-bottom: 1px solid #eee;
          flex-shrink: 0;
        }

        .hrsidebar-avatar {
          width: 42px;
          height: 42px;
          border-radius: 10px;
          background: #4b3df5;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 18px;
          flex-shrink: 0;
        }

        .hrsidebar-welcome {
          font-size: 13px;
          color: #888;
          margin: 0;
        }

        .hrsidebar-username {
          font-size: 15px;
          font-weight: 600;
          color: #1a1a1a;
          margin: 0;
          text-transform: lowercase;
        }

        .hrsidebar-stats {
          display: flex;
          justify-content: space-between;
          padding: 12px 16px;
          border-bottom: 1px solid #eee;
          flex-shrink: 0;
        }

        .hrsidebar-stat-label {
          font-size: 11px;
          color: #999;
          margin: 0 0 2px 0;
        }

        .hrsidebar-stat-value {
          font-size: 13px;
          font-weight: 600;
          color: #1a1a1a;
          margin: 0;
        }

        .hrsidebar-menu {
          list-style: none;
          margin: 0;
          padding: 10px 10px;
          flex: 1;
          overflow-y: auto;
        }

        .hrsidebar-menu::-webkit-scrollbar {
          width: 6px;
        }

        .hrsidebar-menu::-webkit-scrollbar-thumb {
          background: #d9d9d9;
          border-radius: 10px;
        }

        .hrsidebar-menu::-webkit-scrollbar-track {
          background: transparent;
        }

        .hrsidebar-link {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          padding: 10px 12px;
          margin-bottom: 4px;
          border-radius: 8px;
          text-decoration: none;
          color: #444;
          font-size: 14px;
          font-weight: 500;
          transition: background 0.2s, color 0.2s;
        }

        .hrsidebar-link:hover {
          background: #f4f2ff;
          color: #4b3df5;
        }

        .hrsidebar-link.active {
          background: #4b3df5;
          color: #ffffff;
        }

        .hrsidebar-link.active .hrsidebar-icon {
          color: #ffffff;
        }

        .hrsidebar-left {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .hrsidebar-icon {
          font-size: 16px;
          color: #6a6a6a;
          flex-shrink: 0;
        }

        .hrsidebar-badge {
          background: #ff4d4f;
          color: #fff;
          font-size: 10px;
          font-weight: 700;
          border-radius: 999px;
          min-width: 18px;
          height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 5px;
        }

        .hrsidebar-upgrade {
          margin: 12px;
          padding: 14px;
          border-radius: 12px;
          background: linear-gradient(135deg, #eaf9ee, #dff5e6);
          text-align: center;
          flex-shrink: 0;
        }

        .hrsidebar-upgrade-title {
          font-size: 13px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 4px 0;
        }

        .hrsidebar-upgrade-text {
          font-size: 11px;
          color: #5a5a5a;
          margin: 0 0 10px 0;
          line-height: 1.4;
        }

        .hrsidebar-upgrade-btn {
          width: 100%;
          padding: 8px 0;
          border: none;
          border-radius: 8px;
          background: #22a04b;
          color: #fff;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
        }

        .hrsidebar-upgrade-btn:hover {
          background: #1c8a40;
        }

        @media (max-width: 768px) {
          .hrsidebar-wrapper {
            width: 200px;
          }
        }
      `}</style>

      <div className="hrsidebar-wrapper">

        <div className="hrsidebar-profile">
          <div className="hrsidebar-avatar">
            {getInitial()}
          </div>
          <div>
            <p className="hrsidebar-welcome">Welcome,</p>
            <p className="hrsidebar-username">{getDisplayName()}</p>
          </div>
        </div>

        <div className="hrsidebar-stats">
          <div>
            <p className="hrsidebar-stat-label">Member ID</p>
            <p className="hrsidebar-stat-value">
              {user?.membership_id || "—"}
            </p>
          </div>
          <div>
            <p className="hrsidebar-stat-label">Total Jobs</p>
            <p className="hrsidebar-stat-value">{totalJobs}</p>
          </div>
        </div>

        <ul className="hrsidebar-menu">
          {menuItems.map((item, index) => (
            <li key={index}>
              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  isActive ? "hrsidebar-link active" : "hrsidebar-link"
                }
              >
                <div className="hrsidebar-left">
                  {item.icon}
                  <span>{item.label}</span>
                </div>

                {item.badge && (
                  <span className="hrsidebar-badge">{item.badge}</span>
                )}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="hrsidebar-upgrade">
          <p className="hrsidebar-upgrade-title">Upgrade Your Plan</p>
          <p className="hrsidebar-upgrade-text">
            Gain more visibility and access premium features.
          </p>
          <button className="hrsidebar-upgrade-btn">
            Upgrade Now
          </button>
        </div>

      </div>
    </>
  );
}

export default HrSidebar;